import React, { useEffect, useState } from 'react';
import { FaCheckCircle, FaEnvelope } from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import content from '../../content';
import './Contact.css';

const { contact } = content;

const emptyForm = Object.fromEntries(contact.fields.map((field) => [field.name, '']));

function Contact() {
  const [formData, setFormData] = useState(emptyForm);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const formspreeEndpoint = process.env.REACT_APP_FORMSPREEIO;

  useEffect(() => {
    AOS.init({ duration: 900, once: true, offset: 80 });
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    fetch(formspreeEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (response.ok) {
          setSubmitted(true);
        } else {
          setError('There was an issue with your submission, please try again.');
        }
      })
      .catch(() => setError('There was an error submitting the form.'));
  };

  return (
    <section id={contact.id} className="contact">
      <div className="contact-inner">
        {contact.label && (
          <div className="section-label" data-aos="fade-up">{contact.label}</div>
        )}
        <h2 className="section-heading" data-aos="fade-up" data-aos-delay="50">
          {contact.heading}
        </h2>
        {contact.intro && (
          <p className="contact-sub" data-aos="fade-up" data-aos-delay="100">
            {contact.intro}
          </p>
        )}

        {!submitted ? (
          <form
            className="contact-form"
            onSubmit={handleSubmit}
            data-aos="fade-up"
            data-aos-delay="150"
          >
            {contact.fields.map((field) => (
              <div className="form-group" key={field.name}>
                <label htmlFor={field.name}>{field.label}</label>
                {field.type === 'textarea' ? (
                  <textarea
                    id={field.name}
                    name={field.name}
                    placeholder={field.placeholder}
                    value={formData[field.name]}
                    onChange={handleInputChange}
                    required={field.required}
                  />
                ) : (
                  <input
                    type={field.type}
                    id={field.name}
                    name={field.name}
                    placeholder={field.placeholder}
                    value={formData[field.name]}
                    onChange={handleInputChange}
                    required={field.required}
                  />
                )}
              </div>
            ))}
            <button type="submit" className="submit-btn">
              {contact.submitLabel}
            </button>
          </form>
        ) : (
          <div className="thank-you-card" data-aos="zoom-in-up">
            <p className="thank-you-message">
              <FaCheckCircle className="success-icon" />
              {contact.successMessage}
            </p>
          </div>
        )}

        {error && (
          <div className="error-card">
            <p className="error-message">{contact.errorMessage}</p>
            <a href={`mailto:${contact.email}`} className="contact-link">
              <FaEnvelope size={18} /> {contact.email}
            </a>
          </div>
        )}
      </div>
    </section>
  );
}

export default Contact;
